import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=038d6c42&"
import script from "./CategoryMenu.vue?vue&type=script&lang=ts&"
export * from "./CategoryMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports